<template>
	<div :class="`hero ${classes}`" :style="bgImage">
		<div class="underlay" v-if="underlay && !bgimg"></div>
		<div class="overlay" :style="`opacity:${overlay}`"></div>

		<!-- Search navigation -->
		<nav v-if="top_menu" :class="['hero-nav', {'is_fixed': scroll_fix}]" ref="heroNav">
			<ul class="hero-nav__list">
				<li :class="['hero-nav__list-item', {'isActive':currentRouteName == 'about'}]">
					<a href="/about">Story</a>
				</li>
				<li :class="['hero-nav__list-item', {'isActive':currentRouteName == 'team'}]">
					<a href="/team">Team</a>
				</li>
				<li :class="['hero-nav__list-item', {'isActive':currentRouteName == 'b-corp'}]">
					<a href="/b-corp">B-Corp</a>
				</li>
				<li :class="['hero-nav__list-item', {'isActive':currentRouteName == 'the-escape-manifesto-book'}]">
					<a href="/the-escape-manifesto-book">Our Book</a>
				</li>
			</ul>
		</nav>

    <slot name="hero__top"></slot>

		<div class="hero__container">
			<slot></slot>
		</div>
	</div>

	<slot name="banner"></slot>

</template>

<script>
	export default {
		name: 'Hero',

		props: {
			classes: {
				type: String
			},
			bgimg: {
				type: [String, Boolean],
				default: false
			},
      underlay: {
        type: Boolean,
				default: true
      },
			overlay: {
				type: Number,
				default: 0.6
			},
			top_menu: {
				type: Boolean,
				default: false
			},
			top_menu_name: {
				type: String,
				default: 'search'
			}
		},

		data() {
			return {
				scroll_fix:false,
				path_array: false
			}
		},

		created() {
			this.path_array = window.location.pathname.split('/');

			if (this.top_menu) {
				window.addEventListener("scroll", this.onScroll)
			}
		},

		beforeUnmount() {
			if (this.top_menu) {
				window.removeEventListener("scroll", this.onScroll)
			}
		},

		methods: {
			onScroll(e) {
		    let windowTop = window.top.scrollY
		    this.scroll_fix = (windowTop > 60);
		  }
		},

		computed: {
			currentRouteName() {
				if (this.path_array.length === 2) {
					return this.path_array[1];
				} else if (this.path_array.length > 2) {
					return this.path_array[2];
				}
        return '';
    	},
      bgImage() {
        if (this.bgimg) {
          return `background-image: url(${this.$filters.analyseImage(this.bgimg, 'heroxl', 'hero2xl')})`
        }
      }
		}
	}
</script>
